<template>
  <AppSelect
    :label="$tt('education')"
    :items="toSelectItems(options)"
    :hint="$tt('select_education')"
    :rules="[required]"
  />
</template>

<script setup lang="ts">
import { toSelectItems } from '~/helpers/general';
import type { Education } from '~/types';

const { tt } = useLocalization();
const { required } = useValidation();

const options: Record<Education, string> = {
  highschool: tt('highschool'),
  professional: tt('professional'),
  academic: tt('academic'),
  other: tt('other')
};
</script>